export const IPHONEX_WIDTH = 375;
export const IPHONEX_PLUS_WIDTH = 414;
export const TABLET_WIDTH = 517;
export const DESKTOP_WIDTH = 700;
